import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { supabase } from "./supabaseClient";
import Login from "./Login";
import Map from "./Map";
import UpdatePassword from "./UpdatePassword";
import Landing from "./Landing";
import About from "./About";
import Saved from "./Saved";

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

const [loading, setLoading] = useState(true);

useEffect(() => {
  supabase.auth.getSession().then(({ data: { session } }) => {
    setSession(session);
    setLoading(false);
  });

  const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
    setSession(session);
  });

  return () => listener.subscription.unsubscribe();
}, []);

if (loading) {
  return <div className="p-8 text-center text-lg">Loading...</div>;
}


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={session ? <Navigate to="/app" /> : <Login />} />
        <Route path="/app" element={session ? <Map /> : <Navigate to="/login" />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/saved" element={session ? <Saved /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}
